// app.js
import initHomepage from './templates/homepage';
import initTooltip from './vendors/initTooltip';
import {activateCardLinks} from './utils/domUtils';
import initMenu from './components/menu';
import initHorizontalMobile from "./components/scrollbar-horizontal";
import initMobileMenu  from "./components/menu-mobile";
//import {initMultiLevelMenu} from "./components/menu-mobile";
import initPost from "./templates/posts";
import initArchiveFilter from './utils/archiveFilter';
import initArchiveComponent from './utils/archiveComponent';
import initAudioPlayer from "./utils/audioplayer";
import initMultiDropdown from './components/initMultiDropdown';
import initAdvancedFiltersToggle, { initCptHorizontalScroll } from './components/search';
import initAdvancedExpandAreaToggle from './components/expandAreaWithFilters';
import loadMorePress from "./utils/loadMorePress";
import initGenericSliders from "./components/slider-generico";
import initMailchimp from "./utils/newsletter-mailchimp";
import initProjectLabels from "./components/project-label";


document.addEventListener('DOMContentLoaded', () => {

    const bodyClass = document.body.className;

    if (bodyClass.includes('page-template-template-home')) {
        initHomepage();
    }

    initHorizontalMobile('.SearhTag__list');

    if( bodyClass.includes('single-post-class') || bodyClass.includes('page-template') ) {
        initPost();
    }

    if( bodyClass.includes('term-tailor-made') ) {
        const sliderElement = document.querySelectorAll('[data-swiper]');
        if (sliderElement) {
            initGenericSliders();
        }
    }

    if(  document.getElementById('searchByTopic') ) {
        // Dropdown con fetch dinamico
        initMultiDropdown('#searchByTopic', {
            useFetch: true,
            endpoint: '/wp-json/wp/v2/tags?orderby=count&order=desc&per_page=100',
            paramName: 'tags[]',
        });
    }
    if(  document.getElementById('searchByArea') ) {
        // Dropdown con fetch dinamico
        initMultiDropdown('#searchByArea', {
            useFetch: false,
            paramName: 'research_area[]',
        });
    }
    if(  document.getElementById('searchByYear') ) {
        initMultiDropdown('#searchByYear', {
            useFetch: false,
            paramName: 'filter_year[]',
        });
    }
    if(  document.getElementById('searchByMultimediaFormat') ) {
        initMultiDropdown('#searchByMultimediaFormat', {
            useFetch: false,
            paramName: 'format_type[]',
        });
    }

    if(  document.getElementById('searchByPubType') ) {
        initMultiDropdown('#searchByPubType', {
            useFetch: false,
            paramName: 'publication_type[]',
        });
    }

    //else if(  document.getElementById('toggleAdvancedFilters') ) {
    //    console.log("dovresti");
        initAdvancedFiltersToggle();
        initCptHorizontalScroll();
        initAdvancedExpandAreaToggle();
        loadMorePress();
    //}

    initMenu();
    initMobileMenu();
    //initMultiLevelMenu();
    initTooltip();
    activateCardLinks();
    // Inizializza il filtro AJAX per gli archivi
    initArchiveFilter();
    // Inizializza il filtro AJAX per gli archivi new Versione
    initArchiveComponent();
    // Inizializza il player custom
    initAudioPlayer();
    //init Mailchimp
    initMailchimp();
    //init fixed project labels
    initProjectLabels();

});
